<template>
  <div class="gs-app gs-final-affiliate-tracking">
    <tracking></tracking>
  </div>
</template>

<script>
import Tracking from './index.vue';

export default {
  layout: 'defaultForAffiliates',
  components: {
    Tracking,
  },
};
</script>
